module.exports = __webpack_public_path__ + "static/media/intersect.63e4fda8.svg";